const VERSION = '2.0.19a'
export default VERSION
